import Select from 'components/form/Select';
import React, { useState, useEffect } from 'react';
import { getTagList } from 'services/tags.service';

export default function TagSelect({
  onChange,
  placeholder = 'Select or create tags...',
  error = false,
  ...props
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTagList()
      .then((tags) => {
        const tagNames = tags.map((tag) => ({
          label: tag.tag,
          value: tag.tag,
        }));
        setOptions(tagNames);
      })
      .finally(() => setLoading(false));
  }, []);

  const onCreateOption = (newValue) => {
    const newTags = [...options];
    newTags.push({ label: newValue, value: newValue });
    onChange([...props.value, newValue]);
    setOptions(newTags);
  };

  return (
    <Select
      isCreatable
      isMulti
      isLoading={loading}
      closeMenuOnSelect
      transformValue
      margin="none"
      hasError={error}
      fullWidth
      placeholder={placeholder}
      onChange={onChange}
      onCreateOption={onCreateOption}
      options={options}
      menuPosition="fixed"
      {...props}
    />
  );
}
